import React, {Fragment, useEffect, useState} from 'react';
import {Button} from 'primereact/button';
import {SelectButton} from 'primereact/selectbutton';
import {InputText} from 'primereact/inputtext';
import {Dialog} from 'primereact/dialog';
import {Route, Routes} from 'react-router-dom';

import {ConfirmDialogService, ToastService, useDataTable, useDialogCrup, useToolbar} from '@iamsoftware/react-hooks';

import {AgreementTemplateService as Service} from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';

import {FormFields} from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/FormFields';
import {TemplateDetail} from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/TemplateDetail';
import {CommonService} from '../../../service/CommonService';


const statuses = [
  {value: 'N', label: 'Đang hoạt động'},
  {value: 'Y', label: 'Ngừng hoạt động'}
];
export const AgreementTemplates = () => {
  return <AgreementTemplatesMain />;
};

const AgreementTemplatesMain = () => {
  const dataKey = 'agreementId';
  const [statusId, setStatusId] = useState(statuses[0].value);

  const [displayFormFields, setDisplayFormFields] = useState(null);
  const [headerResult, setHeaderResult] = useState(null);
  const [keyword, setKeyword] = useState('');
  const [pseudoIdFormat, setPseudoIdFormat] = useState([])
  const [displayDetail, setDisplayDetail] = useState(null)
  const [fileName, setFileName] = useState('')
  const [displayFile, setDisplayFile] = useState(null);
  const [templateData, setTemplateData] = useState(null)
  const [displayUpload, setDisplayUpload] = useState(false)
  const [displayFileDetail, setDisplayFileDetail] = useState(false)
  const header = `Mẫu hợp đồng`;


  useEffect(() => {
    if (statusId) {
      reloadLazyData();
    }
  }, [statusId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    CommonService.getPseudoIdFormat().then(data => {
      setPseudoIdFormat(data.listData.map(item => {
        return {value: item.enumId, label: item.description}
      }));
    })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    setHeaderResult(tabHeader)
  }, []);


  const {render: renderDataTable, selectedItems, reloadLazyData} = useDataTable({
    tableHeader: headerResult,
    dataKey,
    columns: [
      {
        field: 'agreementPseudoId', header: 'Mã mẫu HĐ', width: 120, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return <span className="underline text-primary" onDoubleClick={() => doUpdate(true, rowData)} title="Double Click để xem chi tiết">{rowData.agreementPseudoId}</span>
        }
      },
      {field: 'agreementName', header: 'Tên mẫu hợp đồng', width: 200, matchMode: 'contains'},
      {field: 'fileName', header: 'Tên file mẫu', width: 200, matchMode: 'contains'},
      {field: 'agreementNoFormatEnum', header: 'Định dạng ', width: 250, matchMode: 'contains'},
      {field: 'agreementDate', header: 'Ngày tạo', width: 120, dataType: 'date'},
      {field: 'description', header: 'Mô tả', width: 200, matchMode: 'contains'},
      {field: 'status', header: 'Trạng thái ', width: 120, matchMode: 'contains'},
    ],
    indexColumnWidth: 45,
    actionColumnWidth: 112,
    getList: lazyLoadEvent => {
      if (statusId) {
        return Service.getAgreementList(statusId, lazyLoadEvent, keyword ? {textSearch: keyword} : undefined)
      } else {
        return Promise.resolve({});
      }
    },
    initActions(items: Array<any>) {
      if (items) {
        items.forEach(item => {
          item.actions = [
            {icon: 'pi pi-pencil', title: 'Chỉnh sửa', className: 'p-button-warning', command: () => doUpdate(false, item)},
            {icon: 'pi pi-eye', title: 'Xem chi tiết', className: 'p-button-info', command: () => doUpdate(true, item)},
          ]
          if (item.statusId === 'AGT_ACTIVE') {
            item.actions.push({icon: 'pi pi-lock', title: 'Khóa', className: 'p-button-danger', command: () => rowLock(item)})
          } else if (item.statusId === 'AGT_INACTIVE') {
            item.actions.push({icon: 'pi pi-unlock', title: 'Mở khóa', className: 'p-button-success', command: () => rowUnLock(item)})
          }
        })

      }
    },
  });
  const displayTemplateFile = () => {
    if (fileName) {
      setDisplayFile(Date.now())
    }
  }
  const {render: renderDialogCrup, create, update} = useDialogCrup({
    header: 'mẫu hợp đồng',
    dataKey,
    width: '40rem',
    fields: [
      {field: 'agreementPseudoId', header: 'Mã mẫu hợp đồng', required: true, className: 'md:col-12'},
      {field: 'agreementName', header: 'Tên mẫu hợp đồng', required: true, className: 'md:col-12'},
      {field: 'agreementNoFormatEnumId', header: 'Định dạng số hợp đồng', required: true, className: 'md:col-12', type: 'Dropdown', DropdownProps: {options: pseudoIdFormat}},
      {
        field: 'contentFile', header: 'File mẫu (.docx)', displayDependency(): boolean {
          return displayUpload
        }, type: 'file', required: true, InputFileProps: {accept: '.docx'}, className: 'md:col-12'
      },
      {
        field: 'fileName', header: 'File mẫu (.docx)', display: displayFileDetail, type: 'custom', className: 'md:col-12',
        body: <Fragment>
          <label>File mẫu (.docx)</label>
          <div className="p-inputgroup flex-1">
            <InputText value={fileName} onChange={(e) => setFileName(e.target.value)} disabled/>
            <span className="p-inputgroup-addon" style={{background: '#22C55E', color: 'white', cursor: 'pointer'}} onClick={() => displayTemplateFile()}>
            <i className="pi pi-eye"/>
          </span>
            <span className="p-inputgroup-addon" style={{background: '#F59E0B', color: 'white', cursor: 'pointer'}} onClick={() => switchState()}>
            <i className="pi pi-pencil"/>
          </span>
          </div>
        </Fragment>
      },
      {field: 'description', header: 'Mô tả', type: 'InputTextarea', className: 'md:col-12'}
    ],
    createItem: async item => {
      return Service.create(await inject(item)).then(data => {
        if (displayUpload === true) {
          setDisplayFormFields(data);
        }
      });
    },
    updateItem: async (id, item) => {
      return Service.update(id, await inject(item)).then(data => {
        if (displayUpload === true) {
          setDisplayFormFields(data);
        }
      });
    },
    reloadLazyData,
    useSaveSplitButton: false
  });


  const inject = async item => {
    if (item.contentFile.length) {
      item.contentFile = item.contentFile[0];
    }
    delete item.categories;
    return Service.toFormData(item);
  }

  const selectedItem: any = (selectedItems && selectedItems[dataKey]) ? selectedItems : null;

  const rowLock = (input) => {
    ConfirmDialogService.confirm('Khóa mẫu hợp đồng', 'Bạn xác nhận khóa mẫu hợp đồng này', () => {
      Service.disable(input.agreementId).then(() => {
        ToastService.success();
        reloadLazyData();
      });
    })
  }
  const rowUnLock = (input) => {
    ConfirmDialogService.confirm('Mở khóa mẫu hợp đồng', 'Bạn xác nhận mở khóa mẫu hợp đồng này?', () => {
      Service.enable(input.agreementId).then(() => {
        ToastService.success();
        reloadLazyData();
      });
    })
  }
  const doUpdate = (doView?: boolean, rowData?: any) => {
    setDisplayUpload(false)
    setDisplayFileDetail(true)
    let _dataKey;
    if (rowData && rowData[dataKey]) {
      _dataKey = rowData[dataKey];
    } else if (selectedItem && selectedItem[dataKey]) {
      _dataKey = selectedItem[dataKey];
    }
    if (_dataKey) {
      if (doView === true) {
        setDisplayDetail({agreementId: _dataKey});
      } else {
        Service.get(_dataKey).then(data => {
          if (data.productCategoryId) {
            data.categories = {value: data.productCategoryId, label: `[${data.categoryPseudoId}] - ${data.categoryName}`}
          }
          setTemplateData(data)
          setFileName(data.fileName)
          update(data);

        });
      }


    }
  }
  const switchState = () => {
    setDisplayFileDetail(false)
    setDisplayUpload(true)
  }
  const doCreate = () => {
    setDisplayUpload(true)
    setDisplayFileDetail(false)
    create()
  }


  const tabHeader = (
    <div>
      <div className="flex align-items-center justify-content-between ">
        <Fragment>
          <span> {header}</span>
          <div className="flex align-items-center gap-2 ml-3">
            <span className="p-input-icon-left">
              <i className="pi pi-search"/>
              <InputText value={keyword} onChange={e => setKeyword(e.target.value)} placeholder="Tìm kiếm..." style={{width: '18rem'}}/>
            </span>
            <Button label="Tìm" icon="pi pi-search" size="small" onClick={() => reloadLazyData()}/>
            <Button label="Xóa" icon="pi pi-times" severity="secondary" size="small" onClick={() => { setKeyword(''); reloadLazyData(); }}/>
          </div>
          <Button label="Tạo mới" icon="pi pi-plus" severity="success" className="mr-2 mb-1 w-8rem h-2rem"
                  size="small" onClick={() => doCreate()}/>
          
        </Fragment>
      </div>
    </div>
  )

  const fileFooter = (
    <div>
      {displayFile && <div>
				<Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFile(false)}/>
			</div>}
    </div>
  );

  return (
    <div className="grid">
      <div className="col-12 pb-0">
        <SelectButton value={statusId} options={statuses} onChange={e => setStatusId(e.value)}/>
      </div>
      <div className="col-12 pb-0" style={{maxHeight: 'calc(100vh - 12rem)'}}>
        {renderDataTable()}
      </div>
      {renderDialogCrup()}
      <FormFields display={displayFormFields} setDisplay={setDisplayFormFields}/>
      <TemplateDetail display={displayDetail} setDisplay={setDisplayDetail}/>
      <Dialog header={`Hợp đồng - ${templateData?.agreementName || templateData?.agreementId}`} draggable={false} footer={fileFooter} visible={!!displayFile} style={{width: '80rem', height: '60rem',}} position="top" onHide={() => setDisplayFile(false)}>
        {templateData?.agreementId &&
					<iframe src={`${Service.baseURL}/${Service.entity}/${templateData.agreementId}/download-pdf?agreementContentId=${templateData.agreementContentId}`} title="Mẫu hợp đồng"
									style={{width: '100%', height: '80vh', border: 'none'}}/>
        }
      </Dialog>
    </div>
  );
}